<template>
  <div>
    <div class="comm_popup_wrap_large">
      <div class="comm_scr_wrap">
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_GBM_CD')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-3">
            <sui-text-field
              v-model="gbmCdText"
              maxlength="100"
              @keyup.enter="onSearchClick"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_GBM_NM')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-3">
            <sui-text-field
              v-model="gbmNmText"
              maxlength="100"
              @keyup.enter="onSearchClick"
            />
          </div>
          <div class="btn_wrap">
            <sui-button
              type="button"
              class="comm_btn_Reset"
              @click="onResetClick"
            >
              {{ $t("MSG_BTN_RESET") }}
            </sui-button>
            <sui-button
              v-permission:read="'PGE_CMY_00018'"
              type="button"
              class="comm_btn_Scr"
              @click="onSearchClick"
            >
              {{ $t("MSG_BTN_SEARCH") }}
            </sui-button>
          </div>
        </div>
      </div>
      <div class="mrB30" />
      <sui-grid
        :columns="gridColumns0"
        :dataset="'dataset0'"
        :rowMovable="false"
        :multiselect="true"
        :pageable="false"
        :showDisplayCountControl="false"
      />
    </div>
    <div class="comm_btn_wrap mrR30">
      <sui-button
        type="button"
        class="comm_btn_border"
        @click="onCloseClick"
      >
        {{ $t("MSG_BTN_CANCEL") }}
      </sui-button>
      <sui-button
        type="button"
        class="comm_btn_solid"
        @click="onApplyClick"
      >
        {{ $t("MSG_BTN_SELT") }}
      </sui-button>
    </div>
  </div>
</template>
<script>
import BasePage from '~cm/components/BasePage';

export default {
  name: 'PGE_CMY_00018_P01', // eslint-disable-line vue/name-property-casing
  extends: BasePage,
  props: {
    pageId: {
      type: String,
      default: 'PGE_CMY_00018',
    },
    siteInfo: {
      type: Object,
      default() {
        return {
          gnrzAreaName: '',
          siteId: '',
          siteAbbName: '',
          gbmCode: '',
          gbmName: '',
        };
      },
    },
  },
  data() {
    return {
      site: this.siteInfo,
      gbmCdText: '',
      gbmNmText: '',
      localdata0: [],
      gridColumns0: [{
        text: this.$t('MSG_TXT_GBM_CD'),
        datafield: 'gbmCode',
        width: 150,
      }, {
        text: this.$t('MSG_TXT_GBM_NM'),
        datafield: 'gbmName',
      }],
    };
  },
  computed: {
    // 계산된 속성, date pickproperty로 사용가능
  },
  watch: {
    // data 변경시 특정 함수를 호출 해야 하는 경우(async 등)
  },
  datasets: [{
    id: 'dataset0',
    type: 'local',
    data: 'localdata0',
    datafields: [{
      name: 'gbmCode',
      type: 'string',
      map: 'gbmCode',
    }, {
      name: 'gbmName',
      type: 'string',
      map: 'gbmName',
    }],
  }],
  mounted() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    onSearchClick() {
      const queryParams = {
        searchGbmCode: utils.trim(this.gbmCdText) || '',
        searchGbmName: utils.trim(this.gbmNmText) || '',
      };

      http.request(this.pageId, 'DTS_CMY_00023', {
        query: queryParams,
      }).then(res => {
        this.localdata0 = res.data;
        this.dataset0.setRawData(this.localdata0);
      }).catch(error => {
        console.log(error);
      });
    },
    onResetClick() {
      this.gbmCdText = '';
      this.gbmNmText = '';
    },
    onCloseClick() {
      this.$emit('close');
    },
    onApplyClick() {
      const selectedIndexes = this.dataset0.getSelectedIndexes();
      const siteData = [];

      utils.forEach(selectedIndexes, index => {
        siteData.push({
          gbmCode: this.dataset0.data[index].gbmCode,
          gbmName: this.dataset0.data[index].gbmName,
        });
      });
      this.site = siteData;

      this.$emit('selected', this.site);
      this.$emit('close');
    },
  },
};
</script>
<style scoped>
</style>
